import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { accessService } from '../../../services/central-api/access';
import { StyleProp, TextStyle } from 'react-native';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../FormDropDownPicker';

type Props = {
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    labelFontSize?: number;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
    label?: string;
    actingBodyId: number | null;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: number[];
    setValue: React.Dispatch<React.SetStateAction<number[]>>;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function ActingBodyUnitsDropdown({ form, fieldName, value, setValue, zIndex, disabled, required, labelFontSize = 16, labelStyle, viewStyle, label, actingBodyId }: Props) {
    const [selectableActingBodyUnits, setSelectableActingBodyUnits] = useState<{ label: string; value: number; }[]>([]);

    async function getActingBodyUnits({ actingBodyId }: { actingBodyId: number; }) {
        try {
            const actingBody = await accessService.getActingBody(actingBodyId);

            if (!actingBody.actingBodyUnits) {
                setSelectableActingBodyUnits([]);
            } else {
                setSelectableActingBodyUnits([
                    ...actingBody.actingBodyUnits.map((role) => {
                        return {
                            value: role.id || 0,
                            label: role.name
                        };
                    })
                ]);
            }
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getActingBodyUnits({ actingBodyId });
        }
    }, [actingBodyId]);

    if (form && fieldName) {
        return <FormDropDownPicker
            label={label ?? translate('unit')}
            items={selectableActingBodyUnits}
            multiple={true}
            mode='BADGE'
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
            labelFontSize={labelFontSize}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />;
    } else if (value !== undefined && setValue !== undefined) {
        return (
            <FilterDropdown
                label={label ?? translate('unit')}
                items={selectableActingBodyUnits}
                multiple={true}
                mode='BADGE'
                setValue={setValue}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
                labelFontSize={labelFontSize}
                labelStyle={labelStyle}
                viewStyle={viewStyle}
            />
        );
    }
}

export default ActingBodyUnitsDropdown;
